import { useState } from 'react';
import { Button, Checkbox } from 'react-materialize';
import { Tabs } from 'antd';
import { useUserDataContext } from '../../contexts/userDataProvider';
import userAPI from '../../services/userAPI';
import { useEdit } from '../common/requests.hooks';
import Loader from '../common/Loader';
import ErrorAlert from '../common/ErrorAlert';
import { defaultLanguage } from '../common/appSettings';
import TermsEn from './TermsEn';
import TermsUa from './TermsUa';

const TermsAndConditions = () => {
  const { data } = useUserDataContext();
  const { selectedLocale } = data ? data[0] : ''; // init tab from user data when available

  const [isAgree, setIsAgree] = useState(false);
  const [langTabSelected, setLangTabSelected] = useState(selectedLocale || defaultLanguage);

  const { isLoading, error, sendEditDataRequest } = useEdit(
    (payload) => userAPI.editUser(payload),
    {
      onSuccess: () => window.location.reload()
    }
  );

  const handleSelectLanguageTabCick = (key) => {
    setLangTabSelected(key);
  };

  const getLocale = (key) => {
    const translations = {
      en: {
        iAcceptTermsAndConditions: 'I accept the terms and conditions',
        submit: 'Submit'
      },
      uk: {
        iAcceptTermsAndConditions: 'Я приймаю положення та умови',
        submit: 'Надіслати'
      }
    };

    return translations[langTabSelected][key];
  };

  const handleSubmit = () => {
    sendEditDataRequest({ isTermsAccepted: isAgree, selectedLocale: langTabSelected });
  };

  const items = [
    {
      key: 'en',
      label: '(EN) English',
      children: <TermsEn />
    },
    {
      key: 'uk',
      label: '(UA) Українська',
      children: <TermsUa />
    }
  ];

  return (
    <div className="terms-and-conditions-wrap">
      <Loader
        setIsLoading={isLoading}
      />
      <ErrorAlert
        error={error}
      />

      <div className="accept-form">
        <Checkbox
          label={getLocale('iAcceptTermsAndConditions')}
          checked={isAgree}
          onChange={() => setIsAgree(!isAgree)}
        />
        <Button
         className="accept-button"
          node="button"
          waves="light"
          type="button"
          disabled={!isAgree}
          onClick={handleSubmit}
        >
          {getLocale('submit')}
        </Button>
      </div>

      <Tabs
        className="tabs"
        items={items}
        onChange={handleSelectLanguageTabCick}
        defaultActiveKey={selectedLocale || defaultLanguage}
      />
    </div>
  );
};

export default TermsAndConditions;
